import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  if (amount === undefined || amount === null) return '\u20b90';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatDate(dateStr) {
  if (!dateStr) return '-';
  try {
    return new Date(dateStr).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return dateStr;
  }
}

export function formatDateTime(dateStr) {
  if (!dateStr) return '-';
  try {
    return new Date(dateStr).toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return dateStr;
  }
}

export const WEEKDAY_NAMES = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export const WEEKDAY_SHORT = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const CHECK_IN_STATUS_LABELS = {
  pending: 'Pending',
  arrived: 'Arrived',
  checked_in: 'Checked In',
  no_show: 'No Show',
  cancelled: 'Cancelled',
};

export const PAYMENT_STATUS_LABELS = {
  not_initiated: 'Not Initiated',
  not_required: 'Not Required',
  initiated: 'Initiated',
  pending: 'Pending',
  paid: 'Paid',
  failed: 'Failed',
  cancelled: 'Cancelled',
};

export const ROLE_LABELS = {
  super_admin: 'Super Admin',
  manager: 'Manager',
  reception: 'Reception',
  finance_viewer: 'Finance Viewer',
  marketing: 'Marketing',
  gate_scan: 'Gate Scanner',
  special_ops: 'Special Events Ops',
};

export function getPaymentStatusClass(status) {
  const map = {
    paid: 'status-paid',
    pending: 'status-pending',
    failed: 'status-failed',
    cancelled: 'status-cancelled',
    not_initiated: 'status-not_initiated',
    initiated: 'status-initiated',
    not_required: 'status-not_required',
  };
  return map[status] || 'status-not_initiated';
}

export function getCheckInStatusClass(status) {
  const map = {
    pending: 'status-pending',
    arrived: 'status-arrived',
    checked_in: 'status-checked_in',
    no_show: 'status-no_show',
    cancelled: 'status-cancelled',
  };
  return map[status] || 'status-pending';
}

export function getTodayString() {
  return new Date().toISOString().split('T')[0];
}

export function getDateDaysAgo(days) {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d.toISOString().split('T')[0];
}

// Customer Type utilities
export const CUSTOMER_TYPE_LABELS = {
  basic: 'Basic',
  old_customer: 'Old Customer',
  elite: 'Elite',
  vip: 'VIP',
  promoter: 'Promoter',
  blacklisted: 'Blacklisted',
};

export const CUSTOMER_TYPE_COLORS = {
  basic: { bg: 'bg-[#3A3A3A]', text: 'text-[#B9B9B9]', border: 'border-[#4A4A4A]' },
  old_customer: { bg: 'bg-amber-500/10', text: 'text-amber-300', border: 'border-amber-500/30' },
  elite: { bg: 'bg-[#D4A843]/15', text: 'text-[#D4A843]', border: 'border-[#D4A843]/30' },
  vip: { bg: 'bg-purple-500/15', text: 'text-purple-400', border: 'border-purple-500/30' },
  promoter: { bg: 'bg-blue-500/15', text: 'text-blue-400', border: 'border-blue-500/30' },
  blacklisted: { bg: 'bg-red-500/15', text: 'text-red-400', border: 'border-red-500/30' },
};

export function getCustomerTypeBadgeClass(customerType) {
  const colors = CUSTOMER_TYPE_COLORS[customerType] || CUSTOMER_TYPE_COLORS.basic;
  return `${colors.bg} ${colors.text} ${colors.border}`;
}
